import userApi from "../../api/userApi";

const state = {
    users: [],
    user: {},
    errors: [],
    filesys: {},
    isAdmin: true,
};

const actions = {
    async getUsers({ commit }) {
        return new Promise((resolve, reject) => {
            userApi.all().then((response) => {
                if (response.status == 200) {
                    commit("SET_USERS", response.data);
                    resolve(response);
                }
                reject(response);
            }).catch((error) => {
                reject(error);
            })
        })
    },
    async getAllUsers({ commit }) {
        return new Promise((resolve, reject) => {
            userApi.allUsers().then((response) => {
                if (response.status == 200) {
                    commit("SET_USERS", response.data);
                    resolve(response);
                }
                reject(response);
            }).catch((error) => {
                reject(error);
            })
        })
    },
    async getCountUsers({ commit }) {
        return new Promise((resolve, reject) => {
            userApi.counterUser().then((response) => {
                if (response.status == 200) {
                    commit("SET_USERS", response.data);
                    resolve(response);
                }
                reject(response);
            }).catch((error) => {
                reject(error);
            })
        })
    },
    async getCountTasks({ commit }) {
        return new Promise((resolve, reject) => {
            userApi.countTasks().then((response) => {
                if (response.status == 200) {
                    commit("SET_USERS", response.data);
                    resolve(response);
                }
                reject(response);
            }).catch((error) => {
                reject(error);
            })
        })
    },
    async getUserById({ commit }, userID) {
        const res = await userApi.show(userID).catch((err) => {
            console.log(err);
            return false;
        });

        if (res.status == 200) {
            commit("SET_USER", res.data);
            return true;
        }
    },
    async updateUser({ commit }, data) {
        const res = await userApi.update(data).catch((err) => {
            if (err.response.data.errors) {
                // return errors to the view and display them
                commit("SET_ERRORS", Object.values(err.response.data.errors));
                // console.log('ERRORS ', err.response.data.errors);
                return false;
            } else {
                // tost: nice error message
                return false;
            }
        });

        if (res.status === 200) {
            commit("UPDATE_ROLE", res.data.userUpdated);
            return true;
        }
    },
    async updateUserProfile({ commit }, data) {

        return new Promise((resolve, reject) => {
            userApi
                .updateProfile(data)
                .then((response) => {
                    if (response.status === 200) {
                        console.log("response :: ", response.data.user);
                        resolve(response);
                        commit("SET_USER", response.data.user)
                    }
                    reject(data);
                })
                .catch((error) => {
                    reject(error);
                })
        })
    },
    updateUserPicture({ commit }, data) {
        return new Promise((resolve, reject) => {
            userApi
                .updatePicture(data)
                .then((res) => {
                    if (res.status === 200) {
                        commit("SET_USER", res.data.user, { module: "userAuth" });
                        let user = JSON.parse(localStorage.getItem("user"));
                        user.picture_small = res.data.user.picture_small;
                        localStorage.removeItem("user");
                        localStorage.setItem("user", JSON.stringify(user));
                        resolve(res);
                    } else {
                        reject(res);
                    }
                })
                .catch((error) => {
                    reject(error.response);
                });
        });
    },

    async updateUserStatus({ commit }, userId) {
        return new Promise((resolve, reject) => {
            userApi
                .updateUserStatus(userId)
                .then((response) => {
                    if (response.status === 200) {
                        commit;
                        resolve(response);
                    } else {
                        reject(response);
                    }
                })
                .catch(error => {
                    reject(error);
                })

        })

    },
    async createUser({ commit }, user) {
        const res = await userApi.store(user).catch((err) => {
            if (err.response.data.errors) {
                // return errors to the view and display them
                commit("SET_ERRORS", Object.values(err.response.data.errors));
                return false;
            } else {
                // tost: nice error message
                return false;
            }
        });

        if (res.status === 201) {
            commit("CREATE_USER", user);
            return true;
        }
    },

    async deleteUser({ commit }, userId) {
        return new Promise((resolve, reject) => {
            userApi
                .delete(userId)
                .then((response) => {
                    if (response.status === 200) {
                        commit("DELETE_USER", userId);
                        resolve(response);
                    }
                    reject(response);
                })
                .catch((error) => {
                    reject(error);
                });
        });
    },

    async resetUserPassword({ commit }, user) {
        return new Promise((resolve, reject) => {
            userApi.resetPassword(user)
            .then((response) => {
                if (response.status === 200) {
                    commit("RESET_USER", response.data.data);
                    resolve(response);
                }
            })
            .catch((error) => {
                reject(error);
            })
        })
    },
    async directories({ commit }) {
        const res = await userApi.addDirectories().catch((err) => {
            console.log(err);
            return false;
        });

        if (res.status === 200) {
            commit("DIRECTORIES", res.data);
            return true;
        }
    },
    async permissions({ commit }, data) {
        const res = await userApi.updatePermission(data).catch((err) => {
            console.log(err);
            return false;
        });

        if (res.status === 200) {
            console.log(commit);
            return true;
        }
    },
};

const mutations = {
    SET_USERS: (state, users) => (state.users = users),

    SET_USER: (state, user) => (state.user = user),

    UPDATE_USER: (state, user) => {
        const index = state.users.findIndex((user) => user.id === user.id);

        if (index !== -1) {
            state.users.splice(index, 1, user);
        }
    },

    RESET_USER: (state, user) => (state.user = user),

    CLEAR_ERROR_STATE: (state) => state.errors.splice(0, state.errors.length),

    CLEAR_USER: (state) => (state.user = {}),

    CREATE_USER: (state, user) => state.users.unshift(user),

    SET_ERRORS: (state, errors) => (state.errors = errors),

    DELETE_USER: (state, userID) => {
        state.users = state.users.filter(
            (user) => user.id !== userID
        );
    },
    DIRECTORIES: (state, dirData) => (state.filesys = dirData),
};

export default { state, actions, mutations };